import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  useLoginMutation,
  useRefreshMutation,
  selectIsLoggedIn,
  getAuthStatus,
  Login,
} from '@centerpiece/components';

export const LoginPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const [login, loginResult] = useLoginMutation();
  const [refresh] = useRefreshMutation();
  const from = (location?.state as any)?.from;

  useEffect(() => {
    if (isLoggedIn) {
      if (from?.pathname) {
        navigate(`${from.pathname}${from.search}${from.hash}`);
      } else {
        navigate('/');
      }
    } else {
      const authStatus = getAuthStatus();
      if (authStatus) {
        refresh();
      }
    }
  }, [isLoggedIn, navigate, from, refresh, loginResult.isSuccess]);

  return <Login login={login} navigate={navigate} />;
};
